import { render } from "./ClaimDetailsModal.vue?vue&type=template&id=4ff25e30&scoped=true"
import script from "./ClaimDetailsModal.vue?vue&type=script&lang=js"
export * from "./ClaimDetailsModal.vue?vue&type=script&lang=js"

import "./ClaimDetailsModal.vue?vue&type=style&index=0&id=4ff25e30&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ff25e30"]])

export default __exports__